import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'hypenation-tickets-hobbs-techsolutely',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './hobbs-techsolutely.component.html',
  styleUrl: './hobbs-techsolutely.component.css',
})
export class HobbsTechsolutelyComponent {}
